import Lookup from 'src/componentes/select2';
import RecursoEdit from 'src/paginas/EscritorioProjetos/Recurso/Edit';

const RecursoLookup = (props) => {
  return (
    <Lookup
      labelKey="nome"
      valueKey="id"
      url="/RecursoLookup"
      editComponent={RecursoEdit}
      {...props}
    />
  );
};

export default RecursoLookup;
